import { render, staticRenderFns } from "./RegionDistrictPortReference.vue?vue&type=template&id=235b99b7&"
import script from "./RegionDistrictPortReference.vue?vue&type=script&lang=js&"
export * from "./RegionDistrictPortReference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports